"use client";
import { Box } from "@chakra-ui/react";
import { PageBlockBreakpoint } from "lib/gcms";
import { MutableRefObject } from "react";
import { PodcastPlatforms } from "./podcast-platforms";
import { PodcastPreview } from "./podcast-preview";
import { WaitlistSection } from "./waitlist-section";

export function PodcastPageBreakpoint(props: PodcastPageBreakpointProps) {
  if (props.highlight === "##EMAIL##") {
    return WaitlistSection(props);
  }
  if (props.highlight === "##PLATFORMS##") {
    return <div ref={props.divRef}>{PodcastPlatforms(props)}</div>;
  }
  if (props.highlight === "##PODCAST_PREVIEW##") {
    return PodcastPreview(props);
  }
  return (
    <Box
      as="section"
      px={{
        base: "12",
        lg: "40",
      }}
      py="12"
      bg={props?.bg}
      color={props?.color}
      textAlign="center"
      sx={{
        "h2 span": {
          fontWeight: "lighter",
          fontSize: {
            base: "lg",
            md: "2xl",
          },
        },
      }}
    >
      {props.content}
    </Box>
  );
}
export interface PodcastPageBreakpointProps extends PageBlockBreakpoint {
  divRef?: MutableRefObject<null>;
}

export default PodcastPageBreakpoint;
